(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
	class StickyHeader extends HTMLElement {
	constructor() {
	super();
	}

	connectedCallback() {
		this.header = document.querySelector('.shopify-section-header');
		this.headerWrapper = document.querySelector('.header-wrapper');
		this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always';
		this.headerBounds = {};
		this.currentScrollTop = 0;
		this.preventReveal = false;
		this.predictiveSearch = this.querySelector('predictive-search');

		this.onScrollHandler = this.onScroll.bind(this);
		this.hideHeaderOnScrollUp = () => this.preventReveal = true;

		this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
		window.addEventListener('scroll', this.onScrollHandler, false);

		this.createObserver();
	}

	disconnectedCallback() {
		this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
		window.removeEventListener('scroll', this.onScrollHandler);
	}

	createObserver() {
		let observer = new IntersectionObserver((entries, observer) => {
		this.headerBounds = entries[0].intersectionRect;
		observer.disconnect();
		});

		if (this.header) {
			observer.observe(this.header);
		}
	}

	onScroll() {
	const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

	if (this.headerIsAlwaysSticky && scrollTop > this.header.offsetHeight + 1) {
		this.header.classList.add('shopify-section-header-sticky','shopify-section-header-always-sticky');
		this.header.style.transform = 'translateY(-100%)';
	};

	if (this.headerIsAlwaysSticky && scrollTop > this.header.offsetHeight + 2) {
		this.header.classList.remove('color-background-2');
		this.header.style.transition = 'background var(--duration-short)';
		this.header.style.transform = 'translateY(0)';
	};

	if (this.headerIsAlwaysSticky && scrollTop < this.header.offsetHeight) {
		this.header.classList.remove('shopify-section-header-sticky');
		this.header.style.transform = 'translateY(0)';
		this.header.style.transition = 'background var(--duration-short)';
		if (this.header.classList.contains('color-background-1')) {
		this.header.classList.add('color-background-2');
		};
	};

	if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
		if (this.preventHide) return;
		requestAnimationFrame(this.hide.bind(this));
		} else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
		if (!this.preventReveal) {
		requestAnimationFrame(this.reveal.bind(this));
		} else {
			window.clearTimeout(this.isScrolling);

			this.isScrolling = setTimeout(() => {
			this.preventReveal = false;
			}, 66);

			requestAnimationFrame(this.hide.bind(this));
		}
		} else if (scrollTop <= this.headerBounds.top) {
		requestAnimationFrame(this.reset.bind(this));
		}

		this.currentScrollTop = scrollTop;
	}

	hide() {
		if (this.headerIsAlwaysSticky) return;		
		if (document.querySelector(".overflow-hidden-tablet")) return;
		this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
		this.closeMenuDisclosure();
	}

	reveal() {
		if (this.headerIsAlwaysSticky) return;
		this.header.classList.add('shopify-section-header-sticky', 'animate');
		this.header.classList.remove('shopify-section-header-hidden','color-background-2');
	}

	reset() {
		if (this.headerIsAlwaysSticky) return;
		this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
		if (this.header.classList.contains('color-background-1')) {
			this.header.classList.add('color-background-2');
		};
	}

	closeMenuDisclosure() {
		this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
		if (this.disclosures) {
			this.disclosures.forEach(disclosure => {
				disclosure.close(); 
			});
		}
		this.disclosureLists = this.header.querySelectorAll('.disclosure__list');
			if (this.disclosureLists) {
				this.disclosureLists.forEach(disclosureList => {
					disclosureList.setAttribute('hidden', true); 
				});
			}
		}
	}

	customElements.define('sticky-header', StickyHeader);


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-items"]) return;
  try {
    
  class CartNote extends HTMLElement {
    constructor() {
      super();

      this.addEventListener(
        'change',
        debounce((event) => {
          const body = JSON.stringify({ note: event.target.value });
          fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } });
        }, 300)
      );
    }
  }

  customElements.define('cart-note', CartNote);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
class ProductModal extends ModalDialog {
	constructor() {
		super();
	}

	hide() {
		super.hide();
		window.pauseAllMedia();
	}

	show(opener) {
		super.show(opener);
		this.showActiveMedia();
	}

	showActiveMedia() {
		const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
		if (activeMedia) {
				activeMedia.classList.add('active');
				activeMedia.scrollIntoView();
		}
		if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMedia.querySelector('template')?.content?.querySelector('.js-youtube'))
			activeMedia.loadContent();
	}
}

customElements.define('product-modal', ProductModal);

// Fair pricing animation
document.addEventListener('DOMContentLoaded', function() {
  const pricingComparison = document.querySelector('.fair-pricing-comparison');
  if (!pricingComparison) return;

  const humblerBar = document.getElementById('humbler-bar');
  const traditionalBar = document.getElementById('traditional-bar');
  const humblerLabel = humblerBar?.querySelector('span');
  const traditionalLabel = traditionalBar?.querySelector('span');
  const humblerPrice = document.getElementById('humbler-price');
  const traditionalPrice = document.getElementById('traditional-price');

  function isInViewport(element) {
    const rect = element.getBoundingClientRect();
    return (
      rect.top >= 0 &&
      rect.left >= 0 &&
      rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
      rect.right <= (window.innerWidth || document.documentElement.clientWidth)
    );
  }

  function animateBars() {
    const isMobile = window.innerWidth <= 768;
    const humblerHeight = '88px';
    const traditionalHeight = '148px';

    setTimeout(() => {
      if (humblerBar && humblerPrice) {
        humblerBar.style.height = humblerHeight;
        humblerPrice.style.bottom = humblerHeight;
        setTimeout(() => {
          humblerLabel.style.opacity = '1';
        }, 1000);
      }
    }, 100);

    setTimeout(() => {
      if (traditionalBar && traditionalPrice) {
        traditionalBar.style.height = traditionalHeight;
        traditionalPrice.style.bottom = traditionalHeight;
        setTimeout(() => {
          traditionalLabel.style.opacity = '1';
        }, 1000);
      }
    }, 300);
  }

  function handleScroll() {
    if (isInViewport(pricingComparison)) {
      animateBars();
      window.removeEventListener('scroll', handleScroll);
    }
  }

  window.addEventListener('scroll', handleScroll);
  handleScroll();
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pendant-quiz-engine"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const DIMENSIONS = [
      'faith',
      'protection',
      'courage',
      'discipline',
      'perspective',
      'mortality',
      'resilience',
      'victory',
      'ambition',
      'wisdom',
      'sacrifice',
      'inner_strength'
    ];

    const FAMILY_DATA = [
      {
        key: 'st_michael', form: 'two_sided', presence: 'bold',
        profile: [5, 5, 4, 2, 1, 0, 3, 2, 0, 1, 3, 2],
        finishes: { gold: 'st-michael-double-sided-pendant', silver: 'st-michael-double-sided-pendant-copy' }
      },
      {
        key: 'death_smile', form: 'coin', presence: 'bold',
        profile: [0, 0, 2, 2, 5, 5, 2, 0, 0, 4, 1, 2],
        finishes: { gold: 'death-smile-memento-mori-coin-pendant', black: 'death-smile-memento-mori-coin-pendant-black' }
      },
      {
        key: 'hard_work', form: 'two_sided', presence: 'balanced',
        profile: [5, 0, 2, 5, 2, 0, 4, 2, 3, 2, 2, 3],
        finishes: { gold: 'hard-work-gods-work-double-sided-pendant-gold', silver: 'hard-work-gods-work-double-sided-pendant-silver' }
      },
      {
        key: 'memento_mori', form: 'two_sided', presence: 'bold',
        profile: [0, 0, 2, 3, 5, 5, 2, 0, 1, 4, 0, 3],
        finishes: { gold: 'memento-mori-double-sided-pendant-gold', silver: 'memento-mori-double-sided-pendant-silver' }
      },
      {
        key: 'hercules', form: 'two_sided', presence: 'bold',
        profile: [0, 1, 4, 2, 2, 1, 5, 3, 2, 3, 2, 3],
        finishes: { gold: 'paradise-flip-gold', silver: 'hell-flip-silver' }
      },
      {
        key: 'trident', form: 'two_sided', presence: 'bold',
        profile: [0, 1, 3, 5, 2, 0, 4, 3, 3, 2, 1, 5],
        finishes: { gold: 'trident-conquer-from-within-double-sided-pendant-gold', silver: 'trident-conquer-from-within-double-sided-pendant-silver' }
      },
      {
        key: 'lions_prayer', form: 'two_sided', presence: 'bold',
        profile: [5, 2, 5, 4, 2, 0, 3, 2, 1, 2, 2, 3],
        finishes: { gold: 'lions-prayer-double-sided-pendant-gold', silver: 'lions-prayer-double-sided-pendant-silver' }
      },
      {
        key: 'warrior', form: 'two_sided', presence: 'bold',
        profile: [0, 1, 4, 3, 1, 1, 4, 5, 4, 1, 1, 3],
        finishes: { gold: 'warrior-veni-vidi-vici-double-sided-pendant-gold', silver: 'warrior-veni-vidi-vici-double-sided-pendant-silver' }
      },
      {
        key: 'spartan_skull', form: 'coin', presence: 'bold',
        profile: [0, 1, 4, 3, 4, 4, 3, 5, 3, 2, 2, 3],
        finishes: { gold: 'veni-vidi-vici-coin-pendant-gold', black: 'spartan-skull-veni-vidi-vici-coin-pendant-black-silver' }
      },
      {
        key: 'icarus', form: 'two_sided', presence: 'bold',
        profile: [0, 0, 2, 1, 4, 3, 2, 1, 5, 5, 1, 2],
        finishes: { gold: 'icarus-double-sided-pendant-gold', silver: 'icarus-double-sided-pendant-silver' }
      },
      {
        key: 'perseus', form: 'coin', presence: 'bold',
        profile: [0, 2, 5, 2, 2, 2, 4, 4, 2, 5, 1, 3],
        finishes: { silver: 'perseus-vs-medusa-coin-pendant' }
      },
      {
        key: 'wings', form: 'figure', presence: 'balanced',
        profile: [0, 0, 3, 3, 1, 0, 3, 5, 4, 1, 0, 3],
        finishes: { gold: 'wings-of-victory-gold', silver: 'wings-of-victory-silver' }
      },
      {
        key: 'spartan_shield', form: 'coin', presence: 'bold',
        profile: [0, 5, 4, 4, 1, 1, 5, 2, 0, 1, 5, 3],
        finishes: { gold: 'spartans-shield-pendant-gold', silver: 'spartans-shield-pendant-silver' }
      },
      {
        key: 'spartan_dagger', form: 'figure', presence: 'bold',
        profile: [0, 1, 4, 4, 1, 1, 3, 3, 4, 1, 2, 5],
        finishes: { gold: 'spartans-dagger-pendant-gold', silver: 'spartans-dagger-pendant-silver' }
      },
      {
        key: 'marcus', form: 'coin', presence: 'balanced',
        profile: [0, 0, 1, 5, 5, 4, 3, 0, 0, 5, 0, 4],
        finishes: { gold: 'marcus-aurelius-memento-mori-coin-pendant' }
      },
      {
        key: 'memento_skull', form: 'coin', presence: 'balanced',
        profile: [0, 0, 2, 3, 5, 5, 2, 0, 0, 3, 0, 3],
        finishes: { gold: 'memento-mori-coin-gold', silver: 'memento-mori-coin-gold-copy' }
      },
      {
        key: 'daggered_rose', form: 'figure', presence: 'balanced',
        profile: [0, 0, 2, 2, 4, 3, 4, 0, 0, 2, 5, 3],
        finishes: { gold: 'daggered-rose-gendant-gold', silver: 'rose-dagger-gold-copy' }
      },
      {
        key: 'essential_cross', form: 'cross', presence: 'quiet',
        profile: [5, 2, 2, 3, 2, 0, 2, 0, 0, 2, 3, 2],
        finishes: { gold: 'essential-cross-gold-pendant', silver: 'essential-cross-pendant-copy' }
      },
      {
        key: 'jesus_piece', form: 'figure', presence: 'balanced',
        profile: [5, 2, 3, 2, 2, 1, 3, 1, 0, 3, 5, 2],
        finishes: { gold: 'jesus-piece', silver: 'jesus-piece-gold-pendant-copy' }
      }
    ];

    const VECTOR_EFFECTS = {
      q2: {
        protection: { protection: 6, courage: 2, faith: 2 },
        mortality: { mortality: 6, perspective: 5, discipline: 1 },
        faith_work: { faith: 6, discipline: 6, resilience: 2 },
        resilience: { resilience: 6, courage: 3, inner_strength: 3 },
        victory: { victory: 6, ambition: 5, courage: 2 },
        inner_strength: { inner_strength: 6, discipline: 5, wisdom: 2 }
      },
      q3: {
        ground: { courage: 5, protection: 4, discipline: 2 },
        day: { perspective: 5, mortality: 4, discipline: 3 },
        faith_work: { faith: 5, discipline: 5, resilience: 2 },
        road: { resilience: 5, sacrifice: 3, wisdom: 2 },
        aim: { ambition: 5, wisdom: 4, victory: 3 }
      },
      q4: {
        courage: { courage: 5, protection: 2 },
        discipline: { discipline: 5, inner_strength: 3 },
        faith: { faith: 5, resilience: 2 },
        resilience: { resilience: 5, sacrifice: 2 },
        ambition: { ambition: 5, victory: 4 }
      }
    };

    const WORLD_BONUSES = {
      biblical: ['st_michael', 'hard_work', 'lions_prayer', 'essential_cross', 'jesus_piece'],
      stoic: ['death_smile', 'memento_mori', 'marcus', 'memento_skull', 'daggered_rose'],
      greek: ['hercules', 'trident', 'icarus', 'perseus', 'wings'],
      warrior: ['warrior', 'spartan_skull', 'spartan_shield', 'spartan_dagger'],
      simple: ['essential_cross', 'wings', 'spartan_dagger', 'daggered_rose']
    };

    const Q6_BRANCHES = {
      faith: {
        question: 'q6_faith',
        bonuses: {
          protector: ['st_michael'],
          believer: ['essential_cross', 'jesus_piece'],
          worker: ['hard_work'],
          underdog: ['lions_prayer']
        }
      },
      perspective: {
        question: 'q6_perspective',
        bonuses: {
          tomorrow: ['death_smile', 'memento_mori'],
          intention: ['memento_skull', 'marcus'],
          clarity: ['marcus'],
          duality: ['daggered_rose', 'death_smile']
        }
      },
      drive: {
        question: 'q6_drive',
        bonuses: {
          fear: ['perseus'],
          survive: ['hercules'],
          finish: ['warrior'],
          rise: ['icarus', 'wings'],
          mastery: ['trident', 'spartan_dagger']
        }
      }
    };

    const Q7_BRANCHES = {
      faith: {
        question: 'q7_faith',
        bonuses: {
          guardian: ['st_michael'],
          daily_work: ['hard_work'],
          devotion: ['essential_cross', 'jesus_piece'],
          prayer: ['lions_prayer']
        }
      },
      courage: {
        question: 'q7_courage',
        bonuses: {
          protect: ['spartan_shield', 'st_michael'],
          fear: ['perseus'],
          pressure: ['hercules', 'st_michael'],
          mastery: ['trident', 'spartan_dagger']
        }
      },
      perspective: {
        question: 'q7_perspective',
        bonuses: {
          urgency: ['death_smile', 'memento_mori'],
          intention: ['memento_skull', 'marcus'],
          clarity: ['marcus'],
          duality: ['daggered_rose', 'death_smile']
        }
      },
      resilience: {
        question: 'q7_resilience',
        bonuses: {
          begin: ['perseus'],
          endure: ['hercules', 'spartan_shield'],
          finish: ['warrior', 'wings'],
          lesson: ['icarus', 'trident']
        }
      },
      ambition: {
        question: 'q7_ambition',
        bonuses: {
          wisdom: ['icarus'],
          discipline: ['trident', 'marcus'],
          courage: ['perseus', 'spartan_dagger'],
          push: ['warrior', 'wings']
        }
      },
      sacrifice: {
        question: 'q7_sacrifice',
        bonuses: {
          love: ['daggered_rose'],
          scars: ['spartan_shield'],
          faith: ['jesus_piece', 'essential_cross'],
          opposites: ['death_smile']
        }
      }
    };

    const CHAIN_HANDLES = {
      cuban: { gold: 'cuban-link-chain-gold-3mm', silver: 'cuban-link-chain-silver-3mm' },
      rope: { gold: '3mm-cuban-link-chain-copy-1', silver: '3mm-cuban-link-chain-copy' },
      wheat: { gold: 'wheat-chain-gold-3mm', silver: 'wheat-chain-silver-3mm' },
      figaro: { gold: 'figaro-chain-gold-3mm', silver: 'figaro-chain-silver-3mm' },
      statement: { gold: 'cuban-link-chain-gold-8mm', silver: 'cuban-link-chain-silver-8mm' }
    };

    const QUESTION_ORDER = ['q1', 'q2', 'q6', 'q5', 'q8', 'q9', 'q10', 'q12'];
    const PRESENCE_ORDER = ['quiet', 'balanced', 'bold'];

    const parseJson = (root, selector) => {
      const script = root.querySelector(selector);
      if (!script) return null;
      try {
        return JSON.parse(script.textContent);
      } catch (error) {
        return null;
      }
    };

    const decodeHtmlEntities = (value) => {
      if (typeof value !== 'string' || !value.includes('&')) return value;
      const decoder = document.createElement('textarea');
      let decoded = value;

      for (let pass = 0; pass < 2; pass += 1) {
        decoder.innerHTML = decoded;
        const next = decoder.value;
        if (next === decoded) break;
        decoded = next;
      }

      return decoded;
    };

    const normalizeCopy = (value) => {
      if (Array.isArray(value)) return value.map(normalizeCopy);
      if (value && typeof value === 'object') {
        return Object.fromEntries(Object.entries(value).map(([key, entry]) => [key, normalizeCopy(entry)]));
      }
      return decodeHtmlEntities(value);
    };

    const replaceToken = (value, token, replacement) => String(value || '').split(token).join(replacement || '');

    const initQuiz = (root) => {
      if (root.dataset.pqReady === 'true') return;
      root.dataset.pqReady = 'true';

      const products = parseJson(root, '[data-pq-products]') || [];
      const bestsellerProducts = parseJson(root, '[data-pq-bestsellers]') || [];
      const chains = parseJson(root, '[data-pq-chains]') || [];
      const copy = normalizeCopy(parseJson(root, '[data-pq-copy]'));
      if (!copy) return;

      const productsByHandle = new Map(products.map((product) => [product.handle, product]));
      const bestsellerRankByHandle = new Map(
        bestsellerProducts.map((product, index) => [product.handle, Number(product.rank) || index + 1])
      );
      const bestsellerPoolEnabled = bestsellerRankByHandle.size > 0;
      const bestsellerWeight = Math.max(0, Number(root.dataset.bestsellerWeight) || 0);
      const chainsByHandle = new Map(chains.map((product) => [product.handle, product]));
      root.dataset.pqBestsellerPoolSize = String(bestsellerRankByHandle.size);
      const sectionId = root.dataset.sectionId;
      const version = root.dataset.quizVersion || 'pendant-quiz-v1';
      const storageKey = `humbler:${version}:${sectionId}`;
      const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      const views = new Map(Array.from(root.querySelectorAll('[data-pq-view]')).map((view) => [view.dataset.pqView, view]));
      const questionTitle = root.querySelector('[data-pq-question-title]');
      const questionNumber = root.querySelector('[data-pq-question-number]');
      const answersWrap = root.querySelector('[data-pq-answers]');
      const questionGrid = root.querySelector('[data-pq-question-grid]');
      const progressCopy = root.querySelector('[data-pq-progress-copy]');
      const progress = root.querySelector('[data-pq-progress]');
      const progressBar = root.querySelector('[data-pq-progress-bar]');
      const liveRegion = root.querySelector('[data-pq-live]');
      let pendingAdvance = 0;
      let resultState = null;

      const renderIcons = () => {
        if (!window.lucide || typeof window.lucide.createIcons !== 'function') return false;
        window.lucide.createIcons({
          attrs: {
            'aria-hidden': 'true',
            'stroke-width': 1.8
          }
        });
        return true;
      };

      const ensureIcons = () => {
        if (renderIcons()) return;
        const script = root.querySelector('script[data-pq-lucide-library]');
        if (!script || script.dataset.pqRenderBound === 'true') return;
        script.dataset.pqRenderBound = 'true';
        script.addEventListener('load', renderIcons, { once: true });
      };

      const mountIcon = (container, name) => {
        const icon = document.createElement('i');
        icon.dataset.lucide = name;
        container.replaceChildren(icon);
      };

      const emptyState = () => ({
        view: 'intro',
        current: 0,
        answers: {},
        personal: {
          email: '',
          phone: ''
        },
        revealed: false,
        sessionId: `${Date.now()}-${Math.random().toString(36).slice(2, 10)}`
      });

      const loadState = () => {
        try {
          const saved = JSON.parse(window.sessionStorage.getItem(storageKey));
          if (!saved || typeof saved !== 'object' || !saved.answers) return emptyState();
          const base = emptyState();
          return {
            ...base,
            ...saved,
            personal: { ...base.personal, ...(saved.personal || {}) },
            sessionId: saved.sessionId || base.sessionId
          };
        } catch (error) {
          return emptyState();
        }
      };

      let state = loadState();
      const hasCompleteAnswers = () => QUESTION_ORDER.every((questionId) => Boolean(state.answers[questionId]));

      const saveState = () => {
        try {
          window.sessionStorage.setItem(storageKey, JSON.stringify(state));
        } catch (error) {
          return;
        }
      };

      const track = (eventName, detail = {}) => {
        const payload = {
          event: `pendant_quiz_${eventName}`,
          quiz_version: version,
          quiz_session_id: state.sessionId,
          ...detail
        };
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push(payload);
        root.dispatchEvent(new CustomEvent(`pendant-quiz:${eventName}`, { bubbles: true, detail: payload }));
      };

      const announce = (message) => {
        if (!liveRegion) return;
        liveRegion.textContent = '';
        window.requestAnimationFrame(() => {
          liveRegion.textContent = message;
        });
      };

      const updateStickyOffset = () => {
        const announcement = document.querySelector('.scrolling-announcement-bar');
        let offset = 0;

        if (announcement) {
          const position = getComputedStyle(announcement).position;
          offset = position === 'fixed' || position === 'sticky'
            ? Math.max(0, announcement.getBoundingClientRect().height)
            : 0;
        }

        root.style.setProperty('--pq-sticky-offset', `${offset}px`);

        const previewBar = document.querySelector('#preview-bar-iframe');
        const previewFrame = document.querySelector('#PBarNextFrame');
        const previewRect = previewBar && previewBar.getBoundingClientRect();
        const previewBarVisible = previewBar
          && getComputedStyle(previewBar).display !== 'none'
          && getComputedStyle(previewBar).visibility !== 'hidden'
          && previewRect.height > 0
          && previewRect.top < window.innerHeight
          && previewRect.bottom >= window.innerHeight - 2;
        const previewFrameVisible = previewFrame
          && getComputedStyle(previewFrame).display !== 'none'
          && getComputedStyle(previewFrame).visibility !== 'hidden';
        const previewBottom = previewBarVisible
          ? previewRect.height
          : previewFrameVisible
            ? 68
            : 0;
        root.style.setProperty('--pq-sticky-bottom', `${previewBottom}px`);

        return offset;
      };

      const scrollToQuiz = () => {
        const top = root.getBoundingClientRect().top + window.scrollY - updateStickyOffset();
        if (Math.abs(window.scrollY - top) < 30) return;
        window.scrollTo({ top, behavior: reduceMotion ? 'auto' : 'smooth' });
      };

      const showView = (name, shouldScroll = true) => {
        views.forEach((view, key) => {
          view.hidden = key !== name;
        });
        state.view = name;
        saveState();
        if (shouldScroll) scrollToQuiz();
      };

      const addVector = (target, additions) => {
        if (!additions) return;
        Object.entries(additions).forEach(([key, value]) => {
          target[key] = (target[key] || 0) + value;
        });
      };

      const buildCustomerVector = () => {
        const vector = Object.fromEntries(DIMENSIONS.map((dimension) => [dimension, 0]));
        ['q2'].forEach((questionId) => {
          addVector(vector, VECTOR_EFFECTS[questionId][state.answers[questionId]]);
        });
        return vector;
      };

      const rankDimensions = (vector = buildCustomerVector()) => (
        DIMENSIONS.slice().sort((a, b) => vector[b] - vector[a])
      );

      const getQ6Branch = () => 'faith';

      const getQ7Branch = () => {
        const vector = buildCustomerVector();
        const clusters = {
          faith: vector.faith + vector.protection * 0.7,
          courage: vector.courage + vector.protection * 0.8 + vector.inner_strength * 0.2,
          perspective: vector.perspective + vector.mortality,
          resilience: vector.resilience + vector.victory,
          ambition: vector.ambition + vector.inner_strength + vector.wisdom * 0.35,
          sacrifice: vector.sacrifice * 1.7 + vector.perspective * 0.2
        };
        return Object.keys(clusters).sort((a, b) => clusters[b] - clusters[a])[0];
      };

      const getQuestion = (index) => {
        const id = QUESTION_ORDER[index];
        if (id === 'q6') return { id, branch: getQ6Branch(), ...copy.questions[Q6_BRANCHES[getQ6Branch()].question] };
        if (id === 'q7') return { id, branch: getQ7Branch(), ...copy.questions[Q7_BRANCHES[getQ7Branch()].question] };
        return { id, ...copy.questions[id] };
      };

      const familyProducts = (family) => Object.entries(family.finishes)
        .map(([finish, handle]) => ({
          finish,
          product: productsByHandle.get(handle),
          bestsellerRank: bestsellerRankByHandle.get(handle) || null
        }))
        .filter(({ product, bestsellerRank }) => (
          product
          && product.available
          && product.image
          && product.variants.some((variant) => variant.available)
          && (!bestsellerPoolEnabled || bestsellerRank)
        ))
        .sort((a, b) => (a.bestsellerRank || Number.MAX_SAFE_INTEGER) - (b.bestsellerRank || Number.MAX_SAFE_INTEGER));

      const hasAvailableFinish = (family, finish) => familyProducts(family).some((entry) => entry.finish === finish);

      const bestsellerPriorityPoints = (rank) => {
        if (!bestsellerPoolEnabled || !rank || !bestsellerWeight) return 0;
        const rankRange = Math.max(1, bestsellerProducts.length - 1);
        const normalizedRank = Math.min(rank - 1, rankRange) / rankRange;
        return bestsellerWeight * (1 - normalizedRank);
      };

      const adaptiveBonus = (familyKey, branchName, answer, branches, points) => {
        const branch = branches[branchName];
        if (!branch || !answer) return 0;
        return (branch.bonuses[answer] || []).includes(familyKey) ? points : 0;
      };

      const scoreFamilies = () => {
        const vector = buildCustomerVector();
        const vectorTotal = DIMENSIONS.reduce((total, dimension) => total + vector[dimension], 0);
        const q6Branch = getQ6Branch();
        const requestedForm = state.answers.q8;
        const requestedFinish = state.answers.q9;
        const requestedPresence = state.answers.q10;

        return FAMILY_DATA.map((family) => {
          const availableProducts = familyProducts(family);
          if (!availableProducts.length) return null;
          const bestsellerRank = availableProducts.reduce(
            (bestRank, entry) => Math.min(bestRank, entry.bestsellerRank || Number.MAX_SAFE_INTEGER),
            Number.MAX_SAFE_INTEGER
          );

          const dotProduct = DIMENSIONS.reduce((total, dimension, index) => total + vector[dimension] * family.profile[index], 0);
          const meaningPoints = vectorTotal ? (40 * dotProduct) / (5 * vectorTotal) : 0;
          const worldPoints = (WORLD_BONUSES[state.answers.q5] || []).includes(family.key) ? 5 : 0;
          const q6Points = adaptiveBonus(family.key, q6Branch, state.answers.q6, Q6_BRANCHES, 4);
          const formPoints = requestedForm === 'auto' || !requestedForm ? 10 : requestedForm === family.form ? 15 : 0;
          let finishPoints = 0;
          if (!requestedFinish) {
            finishPoints = 12;
          } else if (requestedFinish === 'mixed') {
            finishPoints = hasAvailableFinish(family, 'black') ? 15 : 12;
          } else {
            finishPoints = hasAvailableFinish(family, requestedFinish) ? 15 : 0;
          }
          let presencePoints = 0;
          if (!requestedPresence) {
            presencePoints = 5;
          } else {
            const distance = Math.abs(PRESENCE_ORDER.indexOf(requestedPresence) - PRESENCE_ORDER.indexOf(family.presence));
            presencePoints = distance === 0 ? 10 : distance === 1 ? 5 : 0;
          }
          const salesPoints = bestsellerPriorityPoints(bestsellerRank);

          return {
            family,
            bestsellerRank: Number.isFinite(bestsellerRank) ? bestsellerRank : null,
            salesPoints,
            score: meaningPoints + worldPoints + q6Points + formPoints + finishPoints + presencePoints + salesPoints + 5
          };
        }).filter(Boolean).sort((a, b) => b.score - a.score);
      };

      const selectProduct = (family, requestedFinish = state.answers.q9) => {
        const available = familyProducts(family);
        if (!available.length) return null;
        let selected = available.find((entry) => entry.finish === requestedFinish);
        if (!selected) selected = available[0];
        const variant = selected.product.variants.find((item) => item.available) || selected.product.variants[0];
        return {
          ...selected,
          variant,
          finishFallback: Boolean(requestedFinish && requestedFinish !== 'mixed' && selected.finish !== requestedFinish)
        };
      };

      const selectChain = (pendantFinish) => {
        const style = state.answers.q11 || 'cuban';
        const length = state.answers.q12 === 'auto' || !state.answers.q12 ? '22' : state.answers.q12;
        const finish = pendantFinish === 'gold' ? 'gold' : 'silver';
        const handle = CHAIN_HANDLES[style] && CHAIN_HANDLES[style][finish];
        const product = chainsByHandle.get(handle);
        const variant = product && (product.variants.find((item) => item.available && item.title.includes(length)) || product.variants.find((item) => item.available));
        const includedStyle = style === 'cuban' || style === 'rope';
        return {
          style,
          length,
          finish,
          handle,
          product,
          variant,
          included: includedStyle && length === '22',
          optional: !includedStyle || length !== '22'
        };
      };

      const computeResult = () => {
        const ranked = scoreFamilies();
        if (!ranked.length) return null;
        const primary = ranked[0];
        const selection = selectProduct(primary.family);
        if (!selection) return null;
        return {
          ranked,
          primary,
          selection,
          chain: selectChain(selection.finish),
          close: ranked[1] ? primary.score - ranked[1].score <= 4 : false,
          dimensions: rankDimensions()
        };
      };

      const preloadVisualAnswers = (question) => {
        if (!question || !question.visual) return;
        question.answers.forEach((answer) => {
          if (!answer.image) return;
          const image = new Image();
          image.src = answer.image;
        });
      };

      const historyState = () => ({
        pendantQuiz: sectionId,
        view: state.view,
        current: state.current
      });

      const pushHistory = () => {
        try {
          window.history.pushState(historyState(), '', window.location.href);
        } catch (error) {
          return;
        }
      };

      const renderQuestion = (shouldFocus = true) => {
        window.clearTimeout(pendingAdvance);
        const question = getQuestion(state.current);
        const isVisualQuestion = Boolean(question.visual && question.answers.some((answer) => answer.image));
        const selected = state.answers[question.id];
        const currentNumber = state.current + 1;
        questionTitle.textContent = question.prompt;
        questionNumber.textContent = replaceToken(replaceToken(copy.navigation.progress, '__CURRENT__', String(currentNumber)), '__TOTAL__', String(QUESTION_ORDER.length));
        progressCopy.textContent = questionNumber.textContent;
        progress.setAttribute('aria-valuenow', String(currentNumber));
        progressBar.style.width = `${(currentNumber / QUESTION_ORDER.length) * 100}%`;
        answersWrap.replaceChildren();
        answersWrap.classList.toggle('pq__answers--visual', isVisualQuestion);
        answersWrap.classList.toggle('pq__answers--emblems', question.id === 'q2');
        answersWrap.classList.toggle('pq__answers--worlds', question.id === 'q5');
        if (isVisualQuestion) {
          answersWrap.style.setProperty('--pq-visual-columns', String(question.answers.length));
        } else {
          answersWrap.style.removeProperty('--pq-visual-columns');
        }
        if (questionGrid) questionGrid.classList.toggle('is-visual', isVisualQuestion);

        question.answers.forEach((answer, index) => {
          const button = document.createElement('button');
          button.type = 'button';
          button.className = 'pq__answer';
          button.dataset.answer = answer.id;
          button.setAttribute('aria-pressed', selected === answer.id ? 'true' : 'false');
          if (isVisualQuestion) button.setAttribute('aria-label', answer.label);

          const number = document.createElement('span');
          number.className = 'pq__answer-index';
          number.textContent = String(index + 1).padStart(2, '0');
          const label = document.createElement('span');
          label.className = 'pq__answer-label';
          label.textContent = answer.label;
          const icon = document.createElement('span');
          icon.className = 'pq__answer-icon';
          icon.setAttribute('aria-hidden', 'true');
          mountIcon(icon, selected === answer.id ? 'circle-check' : 'circle');
          if (isVisualQuestion && answer.image) {
            button.classList.add('pq__answer--visual');
            const media = document.createElement('span');
            media.className = 'pq__answer-media';
            const image = document.createElement('img');
            image.alt = '';
            image.loading = 'eager';
            image.decoding = 'async';
            image.addEventListener('load', () => media.classList.add('is-loaded'), { once: true });
            image.src = answer.image;
            if (image.complete) media.classList.add('is-loaded');
            media.append(image);

            const meta = document.createElement('span');
            meta.className = 'pq__answer-meta';
            meta.append(number, label, icon);
            button.append(media, meta);
          } else {
            button.append(number, label, icon);
          }

          button.addEventListener('click', () => {
            const previous = state.answers[question.id];
            state.answers[question.id] = answer.id;
            QUESTION_ORDER.slice(state.current + 1).forEach((laterQuestion) => {
              delete state.answers[laterQuestion];
            });
            answersWrap.querySelectorAll('.pq__answer').forEach((item) => {
              const isSelected = item === button;
              item.setAttribute('aria-pressed', isSelected ? 'true' : 'false');
              const iconSlot = item.querySelector('.pq__answer-icon');
              if (iconSlot) mountIcon(iconSlot, isSelected ? 'circle-check' : 'circle');
            });
            ensureIcons();
            saveState();
            track(previous ? 'question_changed' : 'question_answered', {
              question_id: question.id,
              question_number: currentNumber,
              answer_id: answer.id,
              branch: question.branch || null
            });
            announce(answer.label);

            pendingAdvance = window.setTimeout(() => {
              if (state.current < QUESTION_ORDER.length - 1) {
                state.current += 1;
                state.view = 'question';
                saveState();
                pushHistory();
                renderQuestion();
                scrollToQuiz();
              } else {
                resultState = computeResult();
                if (!resultState) return;
                preloadResultImages(resultState);
                track('quiz_completed', {
                  product_family: resultState.primary.family.key,
                  primary_story: resultState.dimensions[0],
                  secondary_story: resultState.dimensions[1]
                });
                if (root.dataset.emailGate === 'false') {
                  state.revealed = true;
                  renderResult();
                } else {
                  renderGate();
                }
                pushHistory();
              }
            }, reduceMotion ? 0 : isVisualQuestion ? 320 : 170);
          });
          answersWrap.append(button);
        });

        ensureIcons();

        showView('question', false);
        if (isVisualQuestion) {
          preloadVisualAnswers(question);
        }
        if (state.current === QUESTION_ORDER.indexOf('q6')) preloadVisualAnswers(copy.questions.q5);
        if (shouldFocus) window.requestAnimationFrame(() => questionTitle.focus({ preventScroll: true }));
      };

      const preloadResultImages = (result) => {
        const urls = [result.selection.product.image];
        result.ranked.slice(1, 3).forEach((entry) => {
          const alternate = selectProduct(entry.family);
          if (alternate && alternate.product.image) urls.push(alternate.product.image);
        });
        urls.forEach((url) => {
          const image = new Image();
          image.src = url;
        });
      };

      const answerLabel = (questionId) => {
        const question = questionId === 'q6' || questionId === 'q7'
          ? getQuestion(QUESTION_ORDER.indexOf(questionId))
          : copy.questions[questionId];
        const answer = question && question.answers.find((item) => item.id === state.answers[questionId]);
        return answer ? answer.label : '';
      };

      const profileText = (result) => {
        const primary = copy.profiles.labels[result.dimensions[0]];
        const secondary = copy.profiles.labels[result.dimensions[1]];
        const presence = answerLabel('q10').toLowerCase();
        const heading = replaceToken(copy.profiles.heading, '__PRIMARY__', primary.toLowerCase());
        const body = replaceToken(
          replaceToken(
            replaceToken(copy.profiles.body, '__SIGNAL_ONE__', primary.toLowerCase()),
            '__SIGNAL_TWO__',
            secondary.toLowerCase()
          ),
          '__PRESENCE__',
          presence
        );
        return { primary, secondary, heading, body };
      };

      const hydrateRevealForm = () => {
        const form = root.querySelector('[data-pq-reveal-form]');
        const personal = state.personal || {};
        form.elements.email.value = personal.email || '';
        form.elements.phone.value = personal.phone || '';
      };

      const renderGate = () => {
        resultState = resultState || computeResult();
        if (!resultState) return;
        const profile = profileText(resultState);
        root.querySelector('[data-pq-profile-eyebrow]').textContent = copy.gate.profileEyebrow;
        root.querySelector('[data-pq-profile-title]').textContent = profile.heading;
        root.querySelector('[data-pq-profile-body]').textContent = profile.body;
        root.querySelector('[data-pq-ready-eyebrow]').textContent = copy.gate.readyEyebrow;
        root.querySelector('[data-pq-ready-title]').textContent = replaceToken(
          replaceToken(copy.gate.readyHeading, '__PRIMARY__', profile.primary.toLowerCase()),
          '__SECONDARY__',
          profile.secondary.toLowerCase()
        );
        root.querySelector('[data-pq-ready-body]').textContent = copy.gate.body;
        hydrateRevealForm();
        const signals = root.querySelector('[data-pq-signals]');
        signals.replaceChildren();
        [answerLabel('q2'), answerLabel('q6'), answerLabel('q10')].filter(Boolean).forEach((signal) => {
          const item = document.createElement('li');
          const icon = document.createElement('i');
          icon.dataset.lucide = 'circle-check';
          const label = document.createElement('span');
          label.textContent = signal;
          item.append(icon, label);
          signals.append(item);
        });
        ensureIcons();
        showView('gate');
        track('reveal_gate_viewed', {
          primary_story: resultState.dimensions[0],
          secondary_story: resultState.dimensions[1]
        });
      };

      const finishLabel = (finish) => copy.chain[finish] || finish;

      const chainNote = (chain) => {
        if (chain.included) return `${copy.result.included}. ${finishLabel(chain.finish)} ${chain.length} inch ${copy.chain[chain.style]}.`;
        if (chain.length !== '22' && (chain.style === 'cuban' || chain.style === 'rope')) return copy.result.includedLengthNote;
        return `${finishLabel(chain.finish)} ${chain.length} inch ${copy.chain[chain.style]}. ${copy.result.included}.`;
      };

      const setCartButtonContent = (cartButton, label, isLoading = false) => {
        if (!cartButton) return;
        const labelNode = cartButton.querySelector('[data-pq-cart-label]');
        if (labelNode) labelNode.textContent = label;
        cartButton.classList.toggle('is-loading', isLoading);
      };

      const quizOrderSource = 'Pendant Quiz';

      const markQuizOrderSource = async (rootPath) => {
        const response = await fetch(`${rootPath}cart/update.js`, {
          method: 'POST',
          headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            attributes: {
              'Order source': quizOrderSource
            }
          })
        });

        if (!response.ok) throw new Error('Quiz order attribution failed');
      };

      const addSelectionToCart = async (button, family, selection) => {
        const variantId = selection.variant && selection.variant.id;
        const cartError = root.querySelector('[data-pq-cart-error]');
        const stickyCartError = root.querySelector('[data-pq-sticky-cart-error]');
        const cartButtons = [
          root.querySelector('[data-pq-product-link]'),
          root.querySelector('[data-pq-sticky-product-link]')
        ].filter(Boolean);
        if (!variantId || cartButtons.some((cartButton) => cartButton.getAttribute('aria-busy') === 'true')) return;

        cartError.hidden = true;
        stickyCartError.hidden = true;
        cartButtons.forEach((cartButton) => {
          cartButton.disabled = true;
          cartButton.setAttribute('aria-busy', 'true');
          setCartButtonContent(cartButton, copy.result.adding, true);
        });
        track('add_to_cart_clicked', {
          product_id: selection.product.id,
          variant_id: variantId,
          product_family: family.key,
          bestseller_rank: selection.bestsellerRank
        });

        try {
          const rootPath = window.Shopify && window.Shopify.routes && window.Shopify.routes.root
            ? window.Shopify.routes.root
            : '/';
          const response = await fetch(`${rootPath}cart/add.js`, {
            method: 'POST',
            headers: {
              'Accept': 'application/json',
              'Content-Type': 'application/json'
            },
            body: JSON.stringify({
              id: variantId,
              quantity: 1,
              properties: {
                '_Quiz source': quizOrderSource,
                '_Quiz version': root.dataset.quizVersion || 'unknown'
              }
            })
          });
          const cartItem = await response.json();
          if (!response.ok) throw new Error(cartItem.description || cartItem.message || 'Cart add failed');

          try {
            await markQuizOrderSource(rootPath);
          } catch (attributionError) {
            track('order_attribution_failed', {
              product_id: selection.product.id,
              variant_id: variantId
            });
          }

          cartButtons.forEach((cartButton) => {
            setCartButtonContent(cartButton, copy.result.added);
          });
          announce(copy.result.added);
          track('added_to_cart', {
            product_id: selection.product.id,
            variant_id: variantId,
            product_family: family.key,
            bestseller_rank: selection.bestsellerRank,
            quantity: 1
          });
          document.dispatchEvent(new CustomEvent('cart:refresh'));

          if (typeof window.customCart === 'object' && typeof window.customCart.update === 'function') {
            try {
              await window.customCart.update();
            } catch (drawerError) {
              document.dispatchEvent(new CustomEvent('open-cart-drawer'));
            }
          } else {
            document.dispatchEvent(new CustomEvent('open-cart-drawer'));
          }

          window.setTimeout(() => {
            cartButtons.forEach((cartButton) => {
              cartButton.disabled = false;
              cartButton.removeAttribute('aria-busy');
              cartButton.classList.remove('is-loading');
            });
            syncResultCartButtonLabel();
            const stickyProductButton = root.querySelector('[data-pq-sticky-product-link]');
            setCartButtonContent(stickyProductButton, copy.result.stickyShop);
          }, 1200);
        } catch (error) {
          cartButtons.forEach((cartButton) => {
            cartButton.disabled = false;
            cartButton.removeAttribute('aria-busy');
            cartButton.classList.remove('is-loading');
          });
          syncResultCartButtonLabel();
          const stickyProductButton = root.querySelector('[data-pq-sticky-product-link]');
          setCartButtonContent(stickyProductButton, copy.result.stickyShop);
          cartError.textContent = copy.result.cartError;
          cartError.hidden = false;
          stickyCartError.textContent = copy.result.cartError;
          stickyCartError.hidden = false;
          announce(copy.result.cartError);
          track('add_to_cart_failed', {
            product_id: selection.product.id,
            variant_id: variantId,
            product_family: family.key
          });
        }
      };

      const updateProductResult = (family, selection) => {
        const familyCopy = copy.families[family.key];
        const imageWrap = root.querySelector('[data-pq-result-media]');
        const image = root.querySelector('[data-pq-result-image]');
        const productButton = root.querySelector('[data-pq-product-link]');
        const cartError = root.querySelector('[data-pq-cart-error]');
        const stickyProductTitle = root.querySelector('[data-pq-sticky-product-title]');
        const stickyProductPrice = root.querySelector('[data-pq-sticky-product-price]');
        const stickyProductButton = root.querySelector('[data-pq-sticky-product-link]');
        const stickyCartError = root.querySelector('[data-pq-sticky-cart-error]');
        const finishNote = root.querySelector('[data-pq-finish-note]');
        const recipient = state.answers.q1;
        const primaryLabel = copy.profiles.labels[resultState.dimensions[0]].toLowerCase();
        const secondaryLabel = copy.profiles.labels[resultState.dimensions[1]].toLowerCase();
        const prefix = recipient === 'known_gift'
          ? `You described someone who values ${primaryLabel} and ${secondaryLabel}. `
          : recipient === 'guided_gift'
            ? `Your answers point to ${primaryLabel} and ${secondaryLabel}. `
            : `You chose ${primaryLabel} and ${secondaryLabel}. `;

        const resultView = views.get('result');
        const requestedImage = selection.product.image;
        imageWrap.classList.remove('is-revealed');
        imageWrap.classList.add('is-loading');
        image.hidden = true;
        image.dataset.requestedSrc = requestedImage;
        const preloader = new Image(1400, 1400);
        preloader.className = 'pq__result-image';
        preloader.alt = selection.product.imageAlt || selection.product.title;
        preloader.decoding = 'async';
        preloader.hidden = true;
        preloader.setAttribute('data-pq-result-image', '');
        preloader.dataset.requestedSrc = requestedImage;
        let imageFinished = false;
        const finishImageReveal = (canShowImage = true) => {
          if (imageFinished || image.dataset.requestedSrc !== requestedImage) return;
          imageFinished = true;
          const revealStartedAt = Number(resultView && resultView.dataset.pqRevealStartedAt) || 0;
          const minimumRevealTime = resultView && resultView.classList.contains('is-revealing') ? 700 : 0;
          const elapsed = revealStartedAt ? performance.now() - revealStartedAt : minimumRevealTime;
          const delay = Math.max(0, minimumRevealTime - elapsed);
          window.setTimeout(() => {
            if (!image.isConnected || image.dataset.requestedSrc !== requestedImage) return;
            if (canShowImage) {
              preloader.hidden = false;
              image.replaceWith(preloader);
            }
            imageWrap.classList.remove('is-loading');
            if (canShowImage) {
              void preloader.offsetWidth;
            }
            imageWrap.classList.add('is-revealed');
            if (resultView && resultView.classList.contains('is-revealing')) {
              resultView.classList.add('is-reveal-ready');
              resultView.classList.remove('is-revealing');
              resultView.removeAttribute('data-pq-reveal-started-at');
              window.setTimeout(() => resultView.classList.remove('is-reveal-ready'), 1100);
            }
          }, delay);
        };
        preloader.onload = () => finishImageReveal(true);
        preloader.onerror = () => finishImageReveal(false);
        preloader.src = requestedImage;
        if (preloader.complete && preloader.naturalWidth > 0) finishImageReveal(true);
        root.querySelector('[data-pq-result-title]').textContent = familyCopy.title;
        root.querySelector('[data-pq-result-story]').textContent = `${prefix}${familyCopy.story}`;
        root.querySelector('[data-pq-product-label]').textContent = copy.result.pendant;
        root.querySelector('[data-pq-product-title]').textContent = selection.product.title;
        const productPrice = selection.variant ? selection.variant.priceFormatted : selection.product.priceFormatted;
        root.querySelector('[data-pq-product-price]').textContent = productPrice;
        productButton.disabled = !selection.variant;
        productButton.dataset.productHandle = selection.product.handle;
        productButton.dataset.bestsellerRank = String(selection.bestsellerRank || '');
        productButton.removeAttribute('aria-busy');
        setCartButtonContent(productButton, selection.variant ? copy.result.shop : copy.result.soldOut);
        cartError.hidden = true;
        stickyProductTitle.textContent = selection.product.title;
        stickyProductPrice.textContent = productPrice;
        stickyProductButton.disabled = !selection.variant;
        stickyProductButton.dataset.productHandle = selection.product.handle;
        stickyProductButton.dataset.bestsellerRank = String(selection.bestsellerRank || '');
        stickyProductButton.removeAttribute('aria-busy');
        setCartButtonContent(stickyProductButton, selection.variant ? copy.result.stickyShop : copy.result.soldOut);
        stickyCartError.hidden = true;
        finishNote.textContent = copy.result.finishNote;
        finishNote.hidden = !selection.finishFallback;

        const finishOptions = root.querySelector('[data-pq-finish-options]');
        finishOptions.replaceChildren();
        familyProducts(family).forEach((option) => {
          const button = document.createElement('button');
          button.type = 'button';
          button.className = 'pq__finish-option';
          button.textContent = finishLabel(option.finish);
          button.setAttribute('aria-pressed', option.finish === selection.finish ? 'true' : 'false');
          button.addEventListener('click', () => {
            const nextSelection = selectProduct(family, option.finish);
            if (!nextSelection) return;
            resultState.selection = nextSelection;
            resultState.chain = selectChain(nextSelection.finish);
            updateProductResult(family, nextSelection);
            syncResultCartButtonLabel();
            renderChain(resultState.chain);
            track('finish_changed', { product_family: family.key, finish: option.finish });
          });
          finishOptions.append(button);
        });

        productButton.onclick = () => addSelectionToCart(productButton, family, selection);
        stickyProductButton.onclick = () => addSelectionToCart(stickyProductButton, family, selection);
      };

      const renderReasons = (result) => {
        const reasons = root.querySelector('[data-pq-reasons]');
        reasons.replaceChildren();
        const primaryLabel = copy.profiles.labels[result.dimensions[0]];
        const reasonValues = [
          replaceToken(copy.profiles.reasonPrimary, '__VALUE__', primaryLabel),
          replaceToken(copy.profiles.reasonForm, '__VALUE__', answerLabel('q8').toLowerCase()),
          replaceToken(copy.profiles.reasonFinish, '__VALUE__', answerLabel('q9'))
        ];
        reasonValues.forEach((reason) => {
          const item = document.createElement('li');
          const icon = document.createElement('i');
          icon.dataset.lucide = 'circle-check';
          const label = document.createElement('span');
          label.textContent = reason;
          item.append(icon, label);
          reasons.append(item);
        });
        ensureIcons();
      };

      const renderChain = (chain) => {
        const status = root.querySelector('[data-pq-chain-status]');
        const title = root.querySelector('[data-pq-chain-title]');
        const note = root.querySelector('[data-pq-chain-note]');
        const link = root.querySelector('[data-pq-chain-link]');
        const image = root.querySelector('[data-pq-chain-image]');
        status.textContent = chain.included ? copy.result.includedChain : copy.result.optionalChain;
        title.textContent = `${finishLabel(chain.finish)} ${copy.chain[chain.style]}`;
        note.textContent = chainNote(chain);
        if (chain.product && chain.product.image) {
          image.src = chain.product.image;
          image.alt = chain.product.imageAlt || chain.product.title;
          image.hidden = false;
        } else {
          image.hidden = true;
        }
        if (chain.optional && chain.product) {
          link.href = chain.variant ? `${chain.product.url}?variant=${chain.variant.id}` : chain.product.url;
          link.textContent = copy.result.chainShop;
          link.hidden = false;
          link.onclick = () => track('chain_clicked', {
            product_id: chain.product.id,
            variant_id: chain.variant && chain.variant.id,
            chain_style: chain.style,
            chain_length: chain.length
          });
        } else {
          link.hidden = true;
        }
      };

      const renderAlternates = (result) => {
        const wrap = root.querySelector('[data-pq-alternates]');
        wrap.replaceChildren();
        result.ranked.slice(1, 3).forEach((entry) => {
          const alternate = selectProduct(entry.family);
          if (!alternate) return;
          const link = document.createElement('a');
          link.className = 'pq__alternate';
          link.href = alternate.product.url;

          const image = document.createElement('img');
          image.src = alternate.product.image;
          image.alt = alternate.product.imageAlt || alternate.product.title;
          image.width = 400;
          image.height = 400;
          image.loading = 'lazy';

          const content = document.createElement('span');
          content.className = 'pq__alternate-copy';
          const eyebrow = document.createElement('span');
          eyebrow.textContent = copy.families[entry.family.key].title;
          const title = document.createElement('strong');
          title.textContent = alternate.product.title;
          const action = document.createElement('small');
          action.textContent = copy.result.another;
          content.append(eyebrow, title, action);
          link.append(image, content);
          link.addEventListener('click', () => track('alternate_viewed', {
            product_family: entry.family.key,
            product_id: alternate.product.id
          }));
          wrap.append(link);
        });
      };

      const syncResultCartButtonLabel = () => {
        const productLink = root.querySelector('[data-pq-product-link]');
        const isGift = state.answers.q1 === 'known_gift' || state.answers.q1 === 'guided_gift';
        setCartButtonContent(
          productLink,
          productLink.disabled
            ? copy.result.soldOut
            : isGift
              ? copy.result.shopGift
              : copy.result.shopPersonal
        );
      };

      const renderResult = () => {
        resultState = resultState || computeResult();
        if (!resultState) return;
        state.revealed = true;
        const resultView = views.get('result');
        resultView.classList.remove('is-reveal-ready');
        resultView.classList.toggle('is-revealing', !reduceMotion);
        if (reduceMotion) {
          resultView.removeAttribute('data-pq-reveal-started-at');
        } else {
          resultView.dataset.pqRevealStartedAt = String(performance.now());
        }
        showView('result');
        root.querySelector('[data-pq-result-eyebrow]').textContent = copy.result.eyebrow;
        updateProductResult(resultState.primary.family, resultState.selection);
        syncResultCartButtonLabel();
        renderReasons(resultState);
        renderChain(resultState.chain);
        renderAlternates(resultState);
        updateStickyOffset();
        window.requestAnimationFrame(updateStickyOffset);
        const closeNote = root.querySelector('[data-pq-close-note]');
        const closeCopy = String(copy.result.closeMatch || '').trim();
        closeNote.textContent = closeCopy;
        closeNote.hidden = !resultState.close || !closeCopy;
        saveState();
        track('result_viewed', {
          product_family: resultState.primary.family.key,
          product_id: resultState.selection.product.id,
          variant_id: resultState.selection.variant && resultState.selection.variant.id,
          bestseller_rank: resultState.selection.bestsellerRank,
          chain_style: resultState.chain.style,
          chain_length: resultState.chain.length
        });
        announce(copy.result.eyebrow);
      };

      const callKlaviyo = async (method, ...args) => {
        const instance = window.klaviyo;
        if (instance && typeof instance[method] === 'function') return instance[method](...args);
        if (instance && typeof instance.push === 'function') {
          instance.push([method, ...args]);
          return true;
        }
        if (window._learnq && typeof window._learnq.push === 'function') {
          window._learnq.push([method === 'track' ? 'track' : 'identify', ...args]);
          return true;
        }
        throw new Error('Klaviyo is unavailable');
      };

      const withTimeout = (promise, timeout = 2200) => Promise.race([
        Promise.resolve(promise),
        new Promise((_, reject) => window.setTimeout(() => reject(new Error('Request timed out')), timeout))
      ]);

      const submitProfile = async (personal) => {
        const result = resultState || computeResult();
        if (!result) return false;
        const alternateOne = result.ranked[1] && result.ranked[1].family.key;
        const alternateTwo = result.ranked[2] && result.ranked[2].family.key;
        const profileProperties = {
          email: personal.email,
          quiz_phone: personal.phone || undefined,
          quiz_recipient: state.answers.q1,
          quiz_primary_story: result.dimensions[0],
          quiz_secondary_story: result.dimensions[1],
          quiz_product_handle: result.selection.product.handle,
          quiz_product_family: result.primary.family.key,
          quiz_bestseller_rank: result.selection.bestsellerRank,
          quiz_finish: result.selection.finish,
          quiz_pendant_form: result.primary.family.form,
          quiz_presence: result.primary.family.presence,
          quiz_chain_handle: result.chain.handle,
          quiz_chain_style: result.chain.style,
          quiz_chain_length: result.chain.length,
          quiz_alternate_one: alternateOne,
          quiz_alternate_two: alternateTwo,
          quiz_completed_at: new Date().toISOString(),
          quiz_version: version,
          quiz_session_id: state.sessionId
        };
        const eventProperties = {
          result_product_id: result.selection.product.id,
          result_variant_id: result.selection.variant && result.selection.variant.id,
          result_product_url: result.selection.product.url,
          result_product_image: result.selection.product.image,
          bestseller_rank: result.selection.bestsellerRank,
          chain_product_id: result.chain.product && result.chain.product.id,
          chain_variant_id: result.chain.variant && result.chain.variant.id,
          story_profile: [result.dimensions[0], result.dimensions[1]],
          phone_provided: Boolean(personal.phone),
          finish: result.selection.finish,
          length: result.chain.length,
          answers: { ...state.answers },
          quiz_version: version,
          quiz_session_id: state.sessionId
        };

        let saved = true;
        try {
          await withTimeout(callKlaviyo('identify', profileProperties));
          await withTimeout(callKlaviyo('track', 'Pendant Quiz Completed', eventProperties));
        } catch (error) {
          saved = false;
        }
        return saved;
      };

      root.querySelector('[data-pq-start]').addEventListener('click', () => {
        state.view = 'question';
        state.current = Math.max(0, Math.min(state.current || 0, QUESTION_ORDER.length - 1));
        saveState();
        pushHistory();
        renderQuestion();
        scrollToQuiz();
        track('started');
      });

      root.querySelector('[data-pq-back]').addEventListener('click', () => {
        window.clearTimeout(pendingAdvance);
        if (state.current === 0) {
          showView('intro');
          state.current = 0;
          saveState();
          track('back', { from_question: 1 });
          return;
        }
        state.current -= 1;
        renderQuestion();
        saveState();
        track('back', { from_question: state.current + 2 });
      });

      const gateContinue = root.querySelector('[data-pq-gate-continue]');
      gateContinue?.addEventListener('click', () => {
        const formPanel = root.querySelector('.pq__form-panel');
        formPanel.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'start' });
        track('gate_continued');
      });

      const revealForm = root.querySelector('[data-pq-reveal-form]');
      revealForm.addEventListener('submit', async (event) => {
        event.preventDefault();
        const form = event.currentTarget;
        const emailInput = form.elements.email;
        const email = String(emailInput.value || '').trim();
        const error = root.querySelector('[data-pq-form-error]');
        const invalidField = form.querySelector(':invalid');
        if (invalidField) {
          error.textContent = copy.gate.emailError;
          error.hidden = false;
          invalidField.focus({ preventScroll: false });
          return;
        }

        const personal = {
          email,
          phone: String(form.elements.phone.value || '').trim()
        };
        state.personal = personal;
        saveState();
        error.hidden = true;
        const button = root.querySelector('[data-pq-reveal]');
        const original = button.textContent;
        button.disabled = true;
        button.textContent = copy.gate.submitting;
        track('reveal_submitted', {
          has_phone: Boolean(personal.phone)
        });
        const saved = await submitProfile(personal);
        button.disabled = false;
        button.textContent = original;
        state.revealed = true;
        saveState();
        renderResult();
        if (!saved) {
          const finishNote = root.querySelector('[data-pq-finish-note]');
          finishNote.textContent = copy.gate.saveNote;
          finishNote.hidden = false;
        }
      });

      root.querySelector('[data-pq-builder-link]')?.addEventListener('click', () => {
        track('set_builder_opened', { product_family: resultState && resultState.primary.family.key });
      });

      root.querySelectorAll('[data-pq-feedback]').forEach((button) => {
        button.addEventListener('click', () => {
          const value = button.dataset.pqFeedback;
          track('feedback_submitted', {
            response: value,
            product_family: resultState && resultState.primary.family.key
          });
          if (value === 'close' && resultState && resultState.ranked[1]) {
            const nextPrimary = resultState.ranked[1];
            const nextSelection = selectProduct(nextPrimary.family);
            if (nextSelection) {
              resultState.primary = nextPrimary;
              resultState.selection = nextSelection;
              resultState.chain = selectChain(nextSelection.finish);
              updateProductResult(nextPrimary.family, nextSelection);
              syncResultCartButtonLabel();
              renderChain(resultState.chain);
              track('alternate_viewed', { product_family: nextPrimary.family.key, source: 'feedback' });
            }
          } else if (value === 'no') {
            QUESTION_ORDER.slice(1).forEach((id) => delete state.answers[id]);
            state.current = 1;
            state.revealed = false;
            resultState = null;
            renderQuestion();
            return;
          }
          root.querySelector('[data-pq-feedback-actions]').hidden = true;
          root.querySelector('[data-pq-feedback-message]').hidden = false;
        });
      });

      root.querySelector('[data-pq-retake]').addEventListener('click', () => {
        state = emptyState();
        resultState = null;
        saveState();
        showView('intro');
        root.querySelector('[data-pq-feedback-actions]').hidden = false;
        root.querySelector('[data-pq-feedback-message]').hidden = true;
        track('retaken');
      });

      window.addEventListener('popstate', (event) => {
        if (!event.state || event.state.pendantQuiz !== sectionId) return;
        state.current = Number(event.state.current) || 0;
        state.view = event.state.view || 'question';
        if (state.view === 'question') renderQuestion(false);
        if (state.view === 'gate') renderGate();
        if (state.view === 'result') renderResult();
      });

      updateStickyOffset();
      window.addEventListener('resize', updateStickyOffset, { passive: true });
      window.addEventListener('scroll', updateStickyOffset, { passive: true });
      const previewBarObserver = new MutationObserver(() => {
        if (!root.isConnected) {
          previewBarObserver.disconnect();
          return;
        }
        updateStickyOffset();
      });
      previewBarObserver.observe(document.body, { childList: true, subtree: true });

      track('viewed');
      if (state.revealed && hasCompleteAnswers()) {
        resultState = computeResult();
        renderResult();
      } else if (state.view === 'gate' && hasCompleteAnswers()) {
        resultState = computeResult();
        renderGate();
      } else if (state.view === 'question' && Object.keys(state.answers).length) {
        renderQuestion(false);
      } else {
        showView('intro', false);
      }
    };

    const initAll = (scope = document) => {
      scope.querySelectorAll('[data-pendant-quiz]').forEach(initQuiz);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initAll());
    } else {
      initAll();
    }

    document.addEventListener('shopify:section:load', (event) => initAll(event.target));
  })();

  } catch(e) { console.error(e); }
})();
})();
